import { Component, Input, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import * as L from 'leaflet';

import { CONFIGURATIONS_ACTION } from '../configurations-detail/configurations-detail.component';

@Component({
  selector: 'app-configurations-template-tile',
  templateUrl: 'configurations-template-tile.component.html',
  styleUrls: ['./configurations-template-tile.component.scss']
})
export class ConfigurationsTemplateTileComponent implements OnInit {
  @ViewChild('scroll') private scroll: ElementRef;

  @Output() onSave = new EventEmitter<any>();
  @Input() data: any;
  @Input('mode') set mode(value: any) {
    this.action = value;
    if (value === CONFIGURATIONS_ACTION.ADD) {
      this.scrollToBottom();
    }
  };
  public actionCheck: any = CONFIGURATIONS_ACTION;
  public action: any = CONFIGURATIONS_ACTION;

  private _url = '//map.thongtingiaothong.vn/transport-full/{z}/{x}/{y}.png';
  private _tileLayerGroup: any[] = [];
  private _urlGroup: any[] = [];
  public userInput: string;
  map: L.Map;

  constructor() { }

  ngOnInit() {
    setTimeout(() => this.initMap(), 300);
  }

  initMap() {
    try {
      this.map = L.map('map', {
        center: L.latLng(10.777093006214637, 106.69547438621521),
        zoom: 14,
        attributionControl: false,
        scrollWheelZoom: false
      });
      L.tileLayer(this._url, {}).addTo(this.map);
    } catch (error) { }
  }

  addTileLayers(url: string) {
    const layer = L.tileLayer(url, {});
    const index = this._urlGroup.indexOf(url);
    if (index > -1) {
      this._tileLayerGroup[index].remove();
      this._urlGroup.splice(index, 1);
      this._tileLayerGroup.splice(index, 1);
    } else {
      this._urlGroup.push(url);
      this._tileLayerGroup.push(layer.addTo(this.map));
    }
  }

  toogleTileLayers(url: string) {
    if (this._urlGroup.indexOf(url) > -1) {
      return 'blue';
    } else {
      return '';
    }
  }

  removeItem(item: any, items: any) {
    const index = items.indexOf(item);
    if (index > -1) {
      items.splice(index, 1);
    }
  }

  addItem(item: any, items: any) {
    if (item) {
      items.push({ url: item });
      this.userInput = '';
      this.onSave.emit(items);
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    try {
      setTimeout(() => {
        this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
      }, 300);
    } catch (err) { }
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations-template-tile/configurations-template-tile.component.ts